export const allConsumedApis = (state) => state.allConsumedApis;

export const getAllInternalApis = (state) => state.allInternalApis;

export const allExposedApis = (state) => state.allExposedApis;

export const allStartFromExternal = (state) => state.startExternalSource;

export const getApiCommitId = (state) => state.apiCommitId;
export const getExposedApiCommitId = (state) => state.exposedApiCommitId;
